/* eslint-disable unicorn/no-await-expression-member */
import { Skeleton } from '@dev-spendesk/grapes';

import { EmptyStateError, lazyLoad } from 'src/core/common/components/LazyLoad';

export const LazyRevealPinScaModal = lazyLoad({
  loader: async () => ({
    default: (
      await import(
        /* webpackChunkName: "SFSRevealPinScaModal", webpackPrefetch: true */ './SFSRevealPinScaModal'
      )
    ).SFSRevealPinScaModal,
  }),
  loading: (
    <div className="relative flex h-full w-full flex-col items-center justify-center text-[56px] text-content-brand-default">
      <Skeleton height="56px" width="100px" />
    </div>
  ),
  fallback: (props) => <EmptyStateError {...props} />,
});
